import React, { useCallback } from 'react';
import {
  Pressable,
  PressableProps,
  PressableStateCallbackType,
  StyleProp,
  ViewStyle,
} from '../web/react-native';

export type StyleType = (state: PressableStateCallbackType) => StyleProp<ViewStyle>;

type PressableWithOpacityProps = Omit<PressableProps, 'style'> & { style?: StyleProp<ViewStyle> };

export default function PressableWithOpacity(props: PressableWithOpacityProps) {
  const { style, ...passThroughProps } = props;
  const _style = useCallback<StyleType>(
    ({ pressed }) => [{ opacity: pressed ? 0.8 : 1 }, style],
    [style],
  );

  return <Pressable style={_style} {...passThroughProps} />;
}
